import { ThemeProvider, CssBaseline } from '@mui/material';
import { useEffect, useRef } from 'react';
import { LoadingContainer } from './components/loading-container/LoadingContainer';
import { MainRouter } from './router/main';
import { theme } from "./styles";
import { AlertContainer } from '../utils/alert-container';
import { useAuthService } from '../use-cases/auth';
import { useAppSelector } from './hooks/store-hooks';
import '../assets/css/leaflet.css'

function App() {
  const { refresh } = useAuthService()
  const token = useAppSelector((state) => state.auth.token)
  const refreshRef = useRef(refresh)
  refreshRef.current = refresh

  useEffect(() => {
    if (!token || token === 'not_valid' || token === '') return

    const intervalSeconds = Number(process.env.REACT_APP_REFRESH_INTERVAL_SECONDS);

    // Chama imediatamente e depois no intervalo
    const interval = setInterval(() => {
      refreshRef.current()
    }, intervalSeconds * 1000)

    return () => clearInterval(interval)
  }, [token]) // apenas token: interval reseta só quando token muda (após refresh bem-sucedido)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LoadingContainer />
      <MainRouter />
      <AlertContainer />
    </ThemeProvider>
  );
}

export default App;